import {
  RETRIEVE_REWARDS,
  TOGGLE_COMPANION,
} from "../actions/types";

const initialState = { campaigns: [], totalCampaignCount: 0, };

const rewardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_REWARDS:
      return {
        ...state,
        campaigns: payload.rows,
        totalCampaignCount: payload.count,
      };

    case TOGGLE_COMPANION: {
      const index = state.campaigns.findIndex(
        (campaign) => Number(campaign.id) === Number(payload.id)
      );

      if (index === -1) return state; // no match found

      const updatedCampaigns = [...state.campaigns];
      updatedCampaigns[index] = { ...updatedCampaigns[index], ...payload };

      return {
        ...state,
        campaigns: updatedCampaigns,
      };
    }


    default:
      return state;
  }
};

export default rewardReducer;